import { render, staticRenderFns } from "./SwitchTabSearch.vue?vue&type=template&id=1375d04d&scoped=true"
import script from "./SwitchTabSearch.vue?vue&type=script&lang=js"
export * from "./SwitchTabSearch.vue?vue&type=script&lang=js"
import style0 from "./SwitchTabSearch.vue?vue&type=style&index=0&id=1375d04d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375d04d",
  null
  
)

export default component.exports